// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__2ZTzS","contentWrapper":"styles_contentWrapper__Axh_Y","content":"styles_content__6jIOr"};